module.exports = __webpack_public_path__ + "img/SDG-15-EN.3e3dc537.png";